export interface IAddEditState {
    optnAlias: string,
    optnName: string,
    nkrAlias: string,
    nkrName: string,
    legalName: string,
    address: string,
    city: string,
    stateId: number,
    postalCode: string,
    opoRegion: number,
    executiveDirector: string,
    medicalDirector: string,
    phoneNumber: string,
    website: string,
    achRoutingNumber: string,
    achAccountNumber: string,
    achApproved: boolean,
    isActive: boolean,
}

export const initialState: IAddEditState = {
    optnAlias: '',
    optnName: '',
    nkrAlias: '',
    nkrName: '',
    legalName: '',
    address: '',
    city: '',
    stateId: 0,
    postalCode: '',
    opoRegion: 0,
    executiveDirector: '',
    medicalDirector: '',
    phoneNumber: '',
    website: '',
    achRoutingNumber: '',
    achAccountNumber: '',
    achApproved: false,
    isActive: true,
};